import _ from 'lodash'

export const asNumber = (value) => {
  const result = _.toNumber(value)
  if (_.isNaN(result)) {
    return undefined
  }
  return result
}
